import { Grid } from '@mui/material';

import { FormTextField, TEXT_AREA_MAX_LENGTH } from '../../../../../../common';

import type { MedicalFieldsProps } from './types';

export default function MedicalHistoryFields({
  formik,
  disabled,
  saveFieldOnBlur,
}: MedicalFieldsProps) {
  return (
    <>
      <Grid item xs={12} sm={6}>
        <FormTextField
          disabled={disabled}
          formik={formik}
          label="Allergies"
          name="allergies"
          onBlur={saveFieldOnBlur}
          placeholder='List allergies (if not applicable, please write "none")'
          required
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <FormTextField
          disabled={disabled}
          formik={formik}
          label="Specific diet"
          name="special_diets"
          onBlur={saveFieldOnBlur}
          placeholder='List specific diet (if not applicable, please write "none")'
          required
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <FormTextField
          disabled={disabled}
          formik={formik}
          label="Trauma history"
          maxLength={TEXT_AREA_MAX_LENGTH}
          minRows={3}
          multiline
          name="trauma_history"
          onBlur={saveFieldOnBlur}
          placeholder="Enter trauma history"
          required
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <FormTextField
          disabled={disabled}
          formik={formik}
          label="Surgical or hospitalization history"
          maxLength={TEXT_AREA_MAX_LENGTH}
          minRows={3}
          multiline
          name="hospitalization_history"
          onBlur={saveFieldOnBlur}
          placeholder="Enter surgical and/or hospitalization history"
          required
        />
      </Grid>
    </>
  );
}
